<template>
  <div id="produce">
    <h2>Nuestros Productos</h2>
    <p class="simple_p">
      Estos son nuestros productos que tenemos para ofrecerle
    </p>
    <div class="list-grid">
      <div v-for="product in products" :key="product.caption" class="grid-item">
        <div class="grid-item-image">Image here</div>
        <div class="grid-item-caption">{{ product.caption }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsSection',
  data() {
    return {
      products: [
        { caption: 'Pequeño' },
        { caption: 'Mediano' },
        { caption: 'Grande' },
        { caption: 'Bloque' }
      ]
    }
  }
}
</script>
